/**
 * Copyright (c) Qwoach LLC 2020. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 7/17/20
 *
 */
import OptionItem from "@shared/OptionItem";

const JournalEntryType = Object.freeze({
	NOTE: "NOTE",
	TASK: "TASK",
	FORM: "FORM",
	FILE: "FILE",
	LEGAL_DOC: "LEGAL_DOC",
	LEGAL_DOC_TEMPLATE: "LEGAL_DOC_TEMPLATE",
	REMINDER: "REMINDER",

})

let journalEntryTypeArray = [
	new OptionItem(JournalEntryType.NOTE, "Note"),
	new OptionItem(JournalEntryType.TASK, "Task"),
	new OptionItem(JournalEntryType.FORM, "Worksheet"),
	new OptionItem(JournalEntryType.FILE, "File or Link"),
	new OptionItem(JournalEntryType.LEGAL_DOC, "Legal Doc"),
]


let journalEntryRowByType = function (journalEntryType){
	switch (journalEntryType) {
		case JournalEntryType.FILE:
		case JournalEntryType.NOTE:
			return 'NoteJournalEntryRow'
		case JournalEntryType.TASK:
			return 'TaskJournalEntryRow'
		case JournalEntryType.FORM:
			return 'FormJournalEntryRow'
		case JournalEntryType.LEGAL_DOC:
			return 'LegalDocJournalEntryRow'
	}
}



let getJournalEntryTypeLabel = function (entryTypeValue) {
	let res = journalEntryTypeArray.find(item => item.value === entryTypeValue)
	return res ? res.label : ""
}


export {
	JournalEntryType,
	journalEntryTypeArray,
	getJournalEntryTypeLabel,
	journalEntryRowByType
}

